import React, { useState,useContext } from 'react';
import { FaStar } from 'react-icons/fa';
import { Feedback } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import { AuthContext } from '../authmanager/authcontext';
import { CartContext } from '../cart/cart';
const Contact = ({toggleTheme}) => {
    const { isLoggedIn, handleLogout } = useContext(AuthContext);
    const {
        cartItems,
        addToCart,
        removeProductByQuantityFromCart,
        finalizeCart,
      } = useContext(CartContext);
  const [formData, setFormData] = useState({
    product: 'Karwan',
    name: '',
    email: '',
    rating: 0,
    comment: ''
  });
  const navigate = useNavigate()
  const [hover, setHover] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleRatingClick = (ratingValue) => {
    setFormData({
      ...formData,
      rating: ratingValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const response = await Feedback(accessToken, formData);
        console.log('Feedback submitted successfully:', response);
      } catch (error) {
        console.error('Error submitting feedback:', error);
      }
    }
    console.log('Form submitted:', formData);
    navigate('/thank-you')
  };

  return (
    <div>
    <Navbar toggleTheme={toggleTheme} isContact={true} handleLogout={handleLogout}finalizeCart={finalizeCart}  />
    <section id="contact" style={styles.section}>
      <h2 style={styles.heading}>Contact</h2>
      <p style={styles.contactDetails}>
        <strong>Email:</strong> abhishek@example.com<br />
        <strong>Phone:</strong> +91-1234567890<br />
        <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/abhishek-ratnam-67b69713b/" target="_blank" rel="noopener noreferrer">linkedin.com/in/abhishek</a>
      </p>
      <h2 style={styles.heading}>Feedback</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label htmlFor="product" style={styles.label}>Product:</label>
          <input
            type="text"
            id="product"
            name="product"
            value={formData.product}
            onChange={handleChange}
            style={styles.input}
            required
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="name" style={styles.label}>Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            style={styles.input}
            required
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="email" style={styles.label}>Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            style={styles.input}
            required
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="rating" style={styles.label}>Rating:</label>
          <div style={styles.rating}>
            {[...Array(5)].map((star, index) => {
              const ratingValue = index + 1;
              return (
                <label key={index}>
                  <input
                    type="radio"
                    name="rating"
                    value={ratingValue}
                    onClick={() => handleRatingClick(ratingValue)}
                    style={styles.radioInput}
                  />
                  <FaStar
                    size={30}
                    color={ratingValue <= (hover || formData.rating) ? "#ffc107" : "#e4e5e9"}
                    onMouseEnter={() => setHover(ratingValue)}
                    onMouseLeave={() => setHover(null)}
                    style={styles.star}
                  />
                </label>
              );
            })}
          </div>
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="comment" style={styles.label}>Comment:</label>
          <textarea
            id="comment"
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            style={styles.textarea}
            required
          />
        </div>
        <button type="submit" style={styles.button}>Send Feedback</button>
      </form>
    </section>
    </div>
  );
};

const styles = {
  section: {
    padding: '20px',
    backgroundColor: '#f4f4f4',
    borderRadius: '8px',
    margin: '20px 0'
  },
  heading: {
    fontSize: '24px',
    marginBottom: '20px',
    color: '#333'
  },
  contactDetails: {
    marginBottom: '20px',
    fontSize: '16px',
    color: '#333'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  formGroup: {
    marginBottom: '15px'
  },
  label: {
    marginBottom: '5px',
    fontSize: '16px',
    color: '#333'
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '1px solid #ccc'
  },
  textarea: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    minHeight: '100px'
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#007BFF',
    color: '#fff',
    cursor: 'pointer',
    alignSelf: 'flex-start'
  },
  rating: {
    display: 'flex',
    flexDirection: 'row'
  },
  radioInput: {
    display: 'none'
  },
  star: {
    cursor: 'pointer',
    transition: 'color 200ms'
  }
};

export default Contact;
